import { TimelineDesignTokens } from '@primeuix/themes/types/timeline';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep, t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/timeline/index.ts
const tl = componentCommon.timeline;
const d = tDeep(tl);

export const TimelineTelekomDT: TimelineDesignTokens = {
  event: {
    minHeight: t(tl.event.min.height),
  },
  eventMarker: {
    size: t(tl.event.marker.size),
    borderRadius: t(tl.event.marker.border.radius),
    borderWidth: t(tl.event.marker.border.width),
    background: t(tl.event.marker.background),
    borderColor: t(tl.event.marker.border.color),
    content: {
      borderRadius: t(tl.event.marker.content.border.radius),
      size: t(tl.event.marker.content.size),
      background: t(tl.event.marker.content.background),
    },
  },
  eventConnector: {
    color: t(tl.event.connector.color),
    size: t(tl.event.connector.size),
  },
  horizontal: {
    eventContent: {
      padding: `${d.horizontal.event.content.padding.y} ${d.horizontal.event.content.padding.x}`,
    },
  },
  vertical: {
    eventContent: {
      padding: `${d.vertical.event.content.padding.y} ${d.vertical.event.content.padding.x}`,
    },
  },
};
